import { Entity } from '../../types';

export function isNotAnAtProperty(propertyName: string): boolean {
  return propertyName?.[0] !== '@';
}

export interface PropertyRevisionData {
  value: any;
  originalValue?: any;
  overridden?: boolean;
  enriched?: boolean;
}

export function propertyRevisionData(
  propertyName: string,
  { properties }: Pick<Entity, 'properties'>
): PropertyRevisionData {
  const atPropertyName = `@${propertyName}`;
  const propertyKeys = Object.keys(properties);
  const propertyValue = properties[propertyName];
  const atPropertyValue = properties[atPropertyName];
  const hasBeenEdited = propertyKeys.includes(atPropertyName);

  return {
    value: propertyValue,
    originalValue: atPropertyValue,
    overridden: hasBeenEdited && Boolean(atPropertyValue),
    enriched: hasBeenEdited && !atPropertyValue,
  };
}
